import React from "react";
import {
    CheckCircleIcon,
    ClockIcon,
    XCircleIcon,
    CurrencyDollarIcon,
} from "@heroicons/react/24/solid";
import { formatDateShort, moneyFormat } from "../utils/utils";
import StatusPill from "./statusPill";

const TransactionDetailsDialog = ({ open, onClose, transaction }) => {
    if (!open || !transaction) return null;

    const getStatusIcon = (status) => {
        return <CheckCircleIcon className="w-7 h-7 text-white-500" />;
    };

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50">
            <div className="bg-white rounded-xl shadow-lg w-full max-w-md mx-4 animate-fadeIn">
                {/* Header */}
                <div className="flex items-center justify-between px-6 py-4 bg-blue-600 rounded-t-xl text-white">
                    <h2 className="text-lg font-semibold">Transaction Details</h2>
                    {getStatusIcon(transaction.status.label)}
                </div>

                {/* Body */}
                <div className="p-6 space-y-4">
                    <div className="flex justify-between">
                        <span className="text-gray-500 text-sm">Reference Number</span>
                        <span className="font-small text-sm">{transaction.reference_number}</span>
                    </div>
                    <div className="flex justify-between">
                        <span className="text-gray-500 text-sm">Category</span>
                        <span className="font-small text-sm">{transaction.transaction_category.category}</span>
                    </div>
                    <div className="flex justify-between">
                        <span className="text-gray-500 text-sm">Date</span>
                        <span className="font-small text-sm">{formatDateShort(transaction.created_at)}</span>
                    </div>

                    <div className="flex justify-between">
                        <span className="text-gray-500 text-sm">Amount</span>
                        <span className="font-semibold text-sm">{moneyFormat(transaction.user_amount)}</span>
                    </div>

                    <div className="flex justify-between">
                        <span className="text-gray-500 text-sm">Status</span>
                        <StatusPill status={transaction.status.label} />
                    </div>

                    <div className="flex justify-between">
                        <span className="text-gray-500 text-sm">Currency</span>
                        <span className="flex items-center gap-1 font-small text-sm">
                            {transaction.user_wallet.currency.code}
                        </span>
                    </div>

                    <div>
                        <span className="text-gray-500 text-sm block mb-1">Description</span>
                        <p className="bg-gray-50 border rounded-md p-3 text-sm text-gray-700">
                            {transaction.description || "No description provided"}
                        </p>
                    </div>

                    <div className="flex justify-between">
                        <span className="text-gray-500 text-sm">Type</span>
                        <span
                            className={`font-semibold text-sm ${transaction.transaction_type === "credit"
                                ? "text-green-600"
                                : "text-red-600"
                                }`}
                        >
                            {transaction.transaction_type.charAt(0).toUpperCase() +
                                transaction.transaction_type.slice(1)}
                        </span>
                    </div>
                </div>

                {/* Footer */}
                <div className="flex justify-end px-6 py-4 border-t">
                    <button
                        onClick={onClose}
                        className="bg-blue-600 text-white px-5 py-2 rounded-lg shadow-md hover:bg-blue-700 transition"
                    >
                        Close
                    </button>
                </div>
            </div>
        </div>
    );
};

export default TransactionDetailsDialog;
